import React from "react";

export default function UserOwnRank({ ownrank }) {
  const { name, rank, quizemark, assignmentmark, total } = ownrank[0];
  return (
    <div>
      <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
      <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
        <thead>
          <tr>
            <th className="table-th !text-center">Rank</th>
            <th className="table-th">Name</th>
            <th className="table-th !text-center">Quiz Mark</th>
            <th className="table-th !text-center">Assignment Mark</th>
            <th className="table-th !text-center">Total</th>
          </tr>
        </thead>

        <tbody>
          <tr className="border-2 border-cyan">
            <td className="table-td text-center font-bold">{rank}</td>
            <td className="table-td font-bold">{name}</td>
            <td className="table-td text-center font-bold">{quizemark}</td>
            <td className="table-td text-center font-bold">{assignmentmark}</td>
            <td className="table-td text-center font-bold">{total}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
